import { useRef, MutableRefObject } from 'react'

export interface UseGetText<T extends HTMLElement> {
    ref: MutableRefObject<T | null>
    getText: (() => string)

}

export function useGetText<T extends HTMLElement>(): UseGetText<T> {
    const ref = useRef<T | null>(null);

    function getText(): string {
        return ref.current?.textContent ?? ""
    }
    return { ref, getText }
}

export default useGetText;
